import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PrestationFichier } from 'src/app/shared/models/prestationFichier';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class PrestationFichierService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllPrestationFichier(): Observable<PrestationFichier[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.prestationFichierUrl}/all`,
			'getAllPrestationFichier'
		);
	}

	importPrestationFichier(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'prestationFichier.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.prestationFichierUrl}/import`,
			`importPrestationFichier`,
			formData
		);
	}

	getPrestationFichierById(id: number): Observable<PrestationFichier> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.prestationFichierUrl}/get/${id}`,
			'getPrestationFichierById'
		);
	}

	getByPrestation(prestationId: number): Observable<PrestationFichier[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.prestationFichierUrl}/getByPrestation/${prestationId}`,
			'getPrestationFichierById'
		);
	}

	updatePrestationFichier(prestationFichier: PrestationFichier): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.prestationFichierUrl}/update/${prestationFichier.id}`,
			'updatePrestationFichier',
			prestationFichier
		);
	}

	addPrestationFichier(prestationFichier: PrestationFichier): Observable<PrestationFichier> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.prestationFichierUrl}/add`,
			'addPrestationFichier',
			prestationFichier
		);
	}

	uploadFile(file: File, prestationFichierId: number): Observable<PrestationFichier> {
		const formData: FormData = new FormData();
		console.log(file);
		formData.append('file', file, file.name);
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.prestationFichierUrl}/uploadFile/${prestationFichierId}`,
			`uploadFile`,
			formData
		);
	}

	deletePrestationFichier(prestationFichierId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.prestationFichierUrl}/delete/${prestationFichierId}`,
			`deletePrestationFichier`
		);
	}

	downloadFile(prestationFIchierId: number): Observable<Blob> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.prestationFichierUrl}/downloadFile/${prestationFIchierId}`,
			'downloadFile',
			{
				responseType: 'blob'
			}
		);
	}
}
